export default (params) => ({
  trigger: {
    name: 'options_row.show_color_alternative_entrance',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'color_collection',
          'upsell_collection',
        ],
      },
    },
    event: {
      name: 'show_content',
    },
    nonInt: true,
  },
});
